(function() {
  var structure = '';

  function gaTaggingSavedList() {
    if ($(document).find('.ph-homepagesavedlist__seeall.ph-float-left').length > 0) {
      window.gaclkFn.linksOnclickGaEvent('.ph-homepagesavedlist__wishlistwrapper', 'saved_lists');
      window.gaclkFn.linksOnclickGaEvent('.ph-homepagesavedlist__seeall.ph-float-left', 'saved_lists');
    }
  }

  function creatingSavedListBoxes(data) {
    data.forEach(function(ele, index) {
      var prodSize = ele.shopWishListImageUrls.length - 3,
          imgTagText = '<img class="ph-freqorderedproduct__image " alt="Saved list product image" src="',
          endDivsTagText = '" /></div></div>';

      if (index <= 3) {
        structure = structure + '<div class="ph-homepagesavedlist__listwrap ph-col-md-3 ph-col-sm-6 ph-col-12 ph-float-left ph-pr-0">\n' +
      '<a class="ph-homepagesavedlist__wishlistwrapper ph-col-12 ph-float-left ph-px-0">';

        if (ele.shopWishListImageUrls.length === 1) {
          structure = structure + '<div class="ph-homepagesavedlist__wishlistbox ph-homepagesavedlist-oneimagewrapper ph-float-left ph-col-12">' +
          '<div class="ph-homepagesavedlist__wishlistinnerbox ph-homepagesavedlist__oneimage ph-float-left ph-col-12">' + imgTagText + ele.shopWishListImageUrls +
          endDivsTagText;
        } else if (ele.shopWishListImageUrls.length === 2 || ele.shopWishListImageUrls.length === 3) {
          ele.shopWishListImageUrls.forEach(function(insideElement) {
            structure = structure + '<div class="ph-homepagesavedlist__wishlistbox ph-float-left ph-col-6">' +
            '<div class="ph-homepagesavedlist__wishlistinnerbox ph-float-left ph-col-12 ph-px-0">' + imgTagText + insideElement + endDivsTagText;
          });
        } else if (ele.shopWishListImageUrls.length > 3) {
          ele.shopWishListImageUrls.forEach(function(insideElement, insideIndex) {
            if (insideIndex < 3) {
              structure = structure + '<div class="ph-homepagesavedlist__wishlistbox ph-float-left ph-col-6">' +
              '<div class="ph-homepagesavedlist__wishlistinnerbox ph-float-left ph-col-12 ph-px-0">' + imgTagText + insideElement + endDivsTagText;
            }
          });
          structure = structure + '<div class="ph-float-left ph-col-6"><div class="ph-homepagesavedlist__wishlistcount ph-float-left ph-col-12">+' + prodSize + '</div></div>';
        }

        structure = structure + '<div class="ph-homepagesavedlist__wishlistname ph-col-12">' + ele.shopWishListName + '</div>\n' +
      '</a>\n' +
      '</div>';
      }
    });

    $('.ph-homepagesavedlist__wishlistmain').html(structure);
    $('.ph-homepagesavedlist__wishlistwrapper').each(function() {
      $(this).attr('href', '/shoppingList/#' + $(this).find('.ph-homepagesavedlist__wishlistname').text().split(' ').join(''));
    });

    if ($('.ph-wishlistsize').val() > 4) {
      $('.ph-homepagesavedlist__seeall').addClass('ph-4products');
    }

    if ($('.ph-wishlistsize').val() > 2) {
      $('.ph-homepagesavedlist__seeall').addClass('ph-2products');
    }
  }

  function loadSavedListContent(container, observer) {
    if ($('.ph-wishlistloaded').length === 0) {
      $('.ph-homepagesavedlist__wishlistmain.ph-float-left').addClass('ph-wishlistloaded');
      $.ajax({
        url: ACC.config.contextPath + '/getFinalWishLists.json',
        async: true,
        success: function(data) {
          creatingSavedListBoxes(data);
          gaTaggingSavedList();
        }
      });
      observer.unobserve(container);
    }
  }

  function setObserverSavedList() {
    var container = document.querySelector('.ph-intersection-observer');

    function intersection() {
      var observer = new IntersectionObserver(function(entries) {
        entries.map(function(entry) {
          var isIntersecting = entry.isIntersecting;

          if (isIntersecting) {
            loadSavedListContent(container, observer);

            observer.observe(container);
          }

          return true;
        }, {

          root: null,

          rootMargin: '0px',

          threshold: 0

        });
      });

      observer.observe(container);
    }

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/vendor/intersection-observer.min.js', function() {
        intersection();
      });
    }
  }

  $(document).ready(function() {
    if (($('.ph-page-homepage').length > 0) && ($('.ph-homepagesavedlist__wishlistmain').length > 0)) {
      setObserverSavedList();
    }
  });
})();
